"use client";
import * as React from 'react';

type Props = React.SelectHTMLAttributes<HTMLSelectElement>;

export function Select({ className = '', children, ...rest }: React.PropsWithChildren<Props>) {
  const cls = ['admin-select', className].filter(Boolean).join(' ');
  return <select className={cls} {...rest}>{children}</select>;
}

export default Select;

